import { Flex, IconDownload, Spinner, Tag, Typography } from '@banhala/ui-kit';
import { localizeNumber } from 'shared/src/utils';
import type { ProductOptionMaxDiscountMode } from '../../../hooks/useProductOptionMaxDiscountMode';

export type CouponState =
  | 'anonymous'
  | 'loading'
  | 'none'
  | 'issued'
  | 'downloadable';

export const CouponStateTag = ({
  state,
  couponCount,
  discount,
  onPressDownload,
  mode = 'disabled',
}: {
  state: CouponState;
  couponCount: number;
  discount: number;
  onPressDownload: () => void;
  mode?: ProductOptionMaxDiscountMode;
}) => {
  if (state === 'loading') {
    return (
      <Flex.Center width={24}>
        <Spinner size={14} />
      </Flex.Center>
    );
  }

  if (state === 'none') {
    return (
      <Typography color={'content_tertiary'} type={'body2'}>
        사용 가능한 쿠폰 없음
      </Typography>
    );
  }

  if (state === 'issued') {
    const maxDiscountLabel =
      mode === 'variantC'
        ? '최대 할인 자동적용'
        : couponCount > 1
          ? '최대 할인'
          : '최대 할인 적용';

    return (
      <Flex.Row alignItems={'center'} gap={8}>
        {couponCount > 1 ? (
          <Flex.Row alignItems={'center'} gap={4}>
            <Tag color="slate" size="small" type="secondary">
              중복쿠폰
            </Tag>
            <Tag color="pink" size="small" type="secondary">
              {maxDiscountLabel}
            </Tag>
          </Flex.Row>
        ) : (
          <Tag color="pink" size="small" type="secondary">
            {maxDiscountLabel}
          </Tag>
        )}
        <Typography
          type={mode === 'disabled' ? 'body2' : 'subtitle2'}
          color={
            mode === 'disabled' ? 'content_primary' : 'content_pink_primary'
          }
        >
          -{localizeNumber(discount)}원
        </Typography>
      </Flex.Row>
    );
  }

  return (
    <Flex onPress={onPressDownload}>
      <Tag color="blue" size="small" type="secondary" icon={IconDownload}>
        최대 할인 쿠폰 받기
      </Tag>
    </Flex>
  );
};
